import request from '@/plugin/axios'
//  获取扫描日志列表
export function getdaylist(params) {
  return request({
    url: '/device/device/getDeviceDataList',
    method: 'get',
    params
  })
}
//  获取串棚提醒
export function getremindlist(data) {
  return request({
    url: '/shed/remind/flyIntoList',
    method: 'post',
    data
  })
}
//  删除串棚提醒
export function delremind(data) {
  return request({
    url: '/shed/remind/flyInOutDelete',
    method: 'post',
    data
  })
}
//  消息通知
export function getremind(params) {
  return request({
    url: '/shed/remind/list',
    method: 'get',
    params
  })
}
//  获取消息数量
export function getMsgsCount(params) {
  return request({
    url: '/shed/remind/getMsgsCount',
    method: 'get',
    params
  })
}
// 全部已读
export function getonekeyRead(params) {
  return request({
    url: '/shed/remind/readMsgs',
    method: 'post'
  })
}
// 单条已读
export function getonekeyReadid(data) {
  return request({
    url: '/shed/remind/readMsgsById',
    method: 'post',
    data
  })
}
// 获取踏板测试，开始/结束
export function getstatus(data) {
  return request({
    url: '/device/device/footNoTest',
    method: 'post',
    data
  })
}
//   获取集鸽器管理列表
export function getcollectorList(params) {
  return request({
    url: '/device/device/collectorList',
    method: 'get',
    params
  })
}
//   修改集鸽通道号
export function passageway(data) {
  return request({
    url: '/device/device/editColAisleCode',
    method: 'post',
    data
  })
}
//   获取关联账号列表数据
export function relationList() {
  return request({
    url: '/device/device/accountList',
    method: 'get'
  })
}
//   集鸽器关联列表确定按钮
export function connectflx(data) {
  return request({
    url: '/device/device/colRelAcc',
    method: 'post',
    data
  })
}

//   设备管理---踏板测试----链接状态
export function linkstatus(data) {
  return request({
    url: '/device/device/isOpen',
    method: 'post',
    data
  })
}
//   获取最上面的集鸽器状态
export function gettopstatus() {
  return request({
    url: '/device/device/getSubStatus',
    method: 'get'

  })
}
//   获取最上面的集鸽器开始/结束订阅
export function starttopstatus(data) {
  return request({
    url: '/device/device/isSubscribe',
    method: 'post',
    data
  })
}
//   比赛名称
export function getname() {
  return request({
    url: `/match/iotMatch/getHomingIotMatch`,
    method: 'get'

  })
}
//   踏板管理列表
export function pedalAdministration(params) {
  return request({
    url: '/device/device/footboardList',
    method: 'get',
    params
  })
}
// 一键添加确定按钮的请求接口
export function getadd() {
  return request({
    url: '/device/device/aKeyToAdd',
    method: 'post'

  })
}
// 踏板测试请求接口
export function gettest(params) {
  return request({
    url: '/device/device/footboardTestList',
    method: 'get',
    params

  })
}
// 扫描日志删除按钮
export function delinfo(data) {
  return request({
    url: '/device/device/delDeviceData',
    method: 'post',
    data

  })
}
// 初始踏板心跳列表
export function defaultinfo() {
  return request({
    url: '/device/device/footboardStatusList',
    method: 'get'

  })
}
// 获取踏板测试状态
export function textstatus() {
  return request({
    url: '/device/device/getFootNoTestStatus',
    method: 'get'

  })
}
// 清空计数
export function clearNum(data) {
  return request({
    url: '/device/device/clearNum',
    method: 'post',
    data

  })
}

// 获取公棚下踏板设备数量
export function getShedFootBoardNum(shedId) {
  return request({
    url: '/device/device/getShedFootBoardNum',
    method: 'get',
    params: {
      shedId
    }
  })
}

// 扫描日志批量导出（进度条）
export function scanLogExport(data) {
  return request({
    url: '/filesys/export/exportDeviceScan',
    method: 'post',
    data
  })
}

// 串棚提醒批量导出（进度条）
export function shedRemindExport(data) {
  return request({
    url: '/filesys/export/exportShedRemind',
    method: 'post',
    data
  })
}
